module.exports = __webpack_public_path__ + "img/khomenko.5fccf11a.jpg";